import React, { useState } from "react";
import { Card, CardContent } from "@mui/material";
import UpgradeStickyBanner from "./utils/UpgradeStickyBanner";
import { useGetOne } from "react-admin";
import UpgradePlanModal from "./components/UpgradePlanModal";

const AirtablePage = () => {
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const profile = JSON.parse(localStorage.getItem("profile"));

  const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;

  const { data: provider } = useGetOne("providers", { id: providerId });
  const isFreemium = provider?.plan === "freemium";
  return (
    <>
      <Card
        sx={{
          width: "100%",
          height: "100%",
          margin: 0,
          padding: 0,
          overflow: "hidden",
          boxShadow: 3,
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        {isFreemium && (
          <UpgradeStickyBanner
            planActual={provider?.plan}
            planDestino="Standard"
            modulo="BENEFICIOS"
            onClickUpgrade={() => setOpenUpgradeModal(true)}
          />
        )}
        <CardContent
          sx={{
            height: "100%",
            padding: 0,
            pointerEvents: isFreemium ? "none" : "auto",
            opacity: isFreemium ? 0.5 : 1,
          }}
        >
          <iframe
            className="airtable-embed"
            src="https://airtable.com/embed/app1FGSxcH2YbrRNt/shrCs6dubN0W0Tlwn/tblDRXEbUdJbA77iP?viewControls=on"
            frameBorder="0"
            width="100%"
            height="100%"
            style={{
              background: "transparent",
              border: "none",
            }}
            title="Airtable"
          />
        </CardContent>
      </Card>
      <UpgradePlanModal
        open={openUpgradeModal}
        onClose={() => setOpenUpgradeModal(false)}
        planActual={provider?.plan}
        planDestino="standard"
      />
    </>
  );
};

export default AirtablePage;
